"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CardHeart = function CardHeart(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M16.063 19.5H7.938c-.69 0-1.25-.56-1.25-1.25V5.75c0-.69.56-1.25 1.25-1.25h8.125c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25zm-.625-9.063A1.875 1.875 0 0012 9.402a1.875 1.875 0 00-3.438 1.035c.001 1.752 2.414 3.36 3.195 4.557a.292.292 0 00.486 0c.78-1.198 3.194-2.805 3.194-4.556v-.001z"
  }));
};

var _default = (0, _react.forwardRef)(CardHeart);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CardHeart, "CardHeart", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/CardHeart.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/CardHeart.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9DYXJkSGVhcnQudHN4Il0sIm5hbWVzIjpbIkNhcmRIZWFydCIsInByb3BzIiwicmVmIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxTQUF5RSxHQUFHLFNBQTVFQSxTQUE0RSxDQUFDQyxLQUFELEVBQVFDLEdBQVI7QUFBQSxTQUNoRjtBQUFLLElBQUEsS0FBSyxFQUFFLEVBQVo7QUFBZ0IsSUFBQSxNQUFNLEVBQUUsRUFBeEI7QUFBNEIsSUFBQSxPQUFPLEVBQUM7QUFBcEMsS0FBb0RELEtBQXBEO0FBQTJELElBQUEsR0FBRyxFQUFFQztBQUFoRSxNQUNFO0FBQ0UsSUFBQSxJQUFJLEVBQUMsY0FEUDtBQUVFLElBQUEsQ0FBQyxFQUFDO0FBRkosSUFERixDQURnRjtBQUFBLENBQWxGOztlQVNlLHVCQUFXRixTQUFYLEM7Ozs7Ozs7Ozs7Ozs7MEJBVFRBLFMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCwgU1ZHUHJvcHMgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IENhcmRIZWFydDogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNMTYuMDYzIDE5LjVINy45MzhjLS42OSAwLTEuMjUtLjU2LTEuMjUtMS4yNVY1Ljc1YzAtLjY5LjU2LTEuMjUgMS4yNS0xLjI1aDguMTI1Yy42OSAwIDEuMjUuNTYgMS4yNSAxLjI1djEyLjVjMCAuNjktLjU2IDEuMjUtMS4yNSAxLjI1em0tLjYyNS05LjA2M0ExLjg3NSAxLjg3NSAwIDAwMTIgOS40MDJhMS44NzUgMS44NzUgMCAwMC0zLjQzOCAxLjAzNWMuMDAxIDEuNzUyIDIuNDE0IDMuMzYgMy4xOTUgNC41NTdhLjI5Mi4yOTIgMCAwMC40ODYgMGMuNzgtMS4xOTggMy4xOTQtMi44MDUgMy4xOTQtNC41NTZ2LS4wMDF6XCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IGZvcndhcmRSZWYoQ2FyZEhlYXJ0KTtcbiJdfQ==